import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  model,
} from '@angular/core';
import { FormValueControl } from '@angular/forms/signals';
import { NgIcon } from '@ng-icons/core';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-input-text',
  imports: [InputTextModule, InputGroupModule, InputGroupAddonModule, NgIcon],
  templateUrl: './input-text.html',
  styleUrl: './input-text.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputText implements FormValueControl<string> {
  inputID = input<string>();
  label = input<string>();
  edit = input<boolean>(false);
  icon = input<string>();
  placeholder = input<string>();

  value = model('');

  readonly resolvedId = computed(() => {
    return this.inputID() ?? `input-${crypto.randomUUID()}`;
  });
}
